<template>
	<q-header elevated class="glossy">
		<AppToolbar />
	</q-header>
	<div>
		<q-splitter v-model="splitterModel" style="height: 1000px">
			<template v-slot:before>
				<div class="q-pa-md">
					<div>
						<div class="q-gutter-sm text-center">
							<q-btn
								style="background: #6c9ad0; color: black"
								@click="showStatus"
								label="Progress Dashboard"
							/>
						</div>
					</div>
					<q-tree
						:nodes="steptree"
						node-key="value"
						label-key="label"
						selected-color="primary"
						v-model:selected="selected"
						default-expand-all
					/>
				</div>
			</template>

			<template v-slot:after>
				<q-tab-panels
					v-model="selected"
					animated
					transition-prev="jump-up"
					transition-next="jump-up"
				>
					<q-tab-panel name="show-status-tab">
						<FormStatus />
					</q-tab-panel>
					<!-- first level tab start -->
					<q-tab-panel name="factory-ourcompany">
						<OurCompany />
					</q-tab-panel>
					<q-tab-panel name="factory-economy">
						<Economy />
					</q-tab-panel>
					<q-tab-panel name="factory-environment">
						<Environment />
					</q-tab-panel>
					<q-tab-panel name="factory-social">
						<Social />
					</q-tab-panel>
					<!-- first level tab end -->

					<q-tab-panel
						v-for="(tab, index) in multiSubAnswersWithChipTabs"
						:key="index"
						:name="tab"
					>
						<BasicStepWithChip
							:label="getLabel(selected)"
							:question="getQuestion(selected)"
							:guildline="getGuildline(selected)"
							:sampleanswers="getSampleAnswers(selected)"
							:picturelabel="getPicLabel(selected)"
							:pictureratio="getPicRatio(selected)"
							:charlimit="getCharactersCount(selected)"
							:step="tab"
						/>
					</q-tab-panel>

					<q-tab-panel
						v-for="(tab, index) in singleAnswerTabs"
						:key="index"
						:name="tab"
					>
						<BasicStepSingleAnswer
							:label="getLabel(selected)"
							:question="getQuestion(selected)"
							:guildline="getGuildline(selected)"
							:sampleanswer="getSampleAnswers(selected)"
							:picturelabel="getPicLabel(selected)"
							:pictureratio="getPicRatio(selected)"
							:charlimit="getCharactersCount(selected)"
							:step="tab"
						/>
					</q-tab-panel>

					<q-tab-panel
						v-for="(tab, index) in multiAnswerTabs"
						:key="index"
						:name="tab"
					>
						<BasicStepMultiAnswer
							:label="getLabel(selected)"
							:question="getQuestion(selected)"
							:guildline="getGuildline(selected)"
							:sampleanswers="getSampleAnswers(selected)"
							:picturelabel="getPicLabel(selected)"
							:pictureratio="getPicRatio(selected)"
							:charlimit="getCharactersCount(selected)"
							:step="tab"
						/>
					</q-tab-panel>

					<q-tab-panel
						v-for="(tab, index) in multiSubAnswersTabs"
						:key="index"
						:name="tab"
					>
						<BasicStepSubAnswer
							:label="getLabel(selected)"
							:question="getQuestion(selected)"
							:guildline="getGuildline(selected)"
							:sampleanswers="getSampleAnswers(selected)"
							:samplesubanswers="getSamplesubanswers(selected)"
							:picturelabel="getPicLabel(selected)"
							:pictureratio="getPicRatio(selected)"
							:charlimit="getCharactersCount(selected)"
							:step="tab"
						/>
					</q-tab-panel>

					<!-- All tables start -->
					<q-tab-panel name="factory-environment-energytable">
						<EnergyUsageTable
							:label="getLabel(selected)"
							:question="getQuestion(selected)"
							:guildline="getGuildline(selected)"
							step="factory-environment-energytable"
						/>
					</q-tab-panel>
					<q-tab-panel name="factory-environment-watertable">
						<WaterUsageTable
							:label="getLabel(selected)"
							:question="getQuestion(selected)"
							:guildline="getGuildline(selected)"
							step="factory-environment-watertable"
						/>
					</q-tab-panel>
					<q-tab-panel name="factory-environment-materialtable">
						<MaterialUsageTable
							:label="getLabel(selected)"
							:question="getQuestion(selected)"
							:guildline="getGuildline(selected)"
							step="factory-environment-materialtable"
						/>
					</q-tab-panel>
					<q-tab-panel name="factory-environment-wastetable">
						<WasteAmountTable
							:label="getLabel(selected)"
							:question="getQuestion(selected)"
							:guildline="getGuildline(selected)"
							step="factory-environment-wastetable"
						/>
					</q-tab-panel>
					<!-- All tables end -->
				</q-tab-panels>
			</template>
		</q-splitter>
	</div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useAuth0 } from "@auth0/auth0-vue";
import stepNode from "./formdata/factorystepnode.json";
import stepQuestions from "./formdata/factoryquestions.json";
import BasicStepMultiAnswer from "./formsteps/BasicStepMultiAnswerTemplate.vue";
import BasicStepSubAnswer from "./formsteps/BasicStepMultiAnswerWithSubTemplate.vue";
import BasicStepSingleAnswer from "./formsteps/BasicStepSingleAnswerTempalte.vue";
import BasicStepWithChip from "./formsteps/BasicStepAnswerWithChipsTemplate.vue";
import EnergyUsageTable from "./formsteps/EnergyUsageTable.vue";
import WaterUsageTable from "./formsteps/WaterUsageTable.vue";
import MaterialUsageTable from "./formsteps/MaterialUsageTable.vue";
import WasteAmountTable from "./formsteps/WasteAmountTable.vue";
import OurCompany from "./formsteps/OurCompany.vue";
import Economy from "./formsteps/Economy.vue";
import Environment from "./formsteps/Environment.vue";
import Social from "./formsteps/Social.vue";
import AppToolbar from "@/components/tools/AppToolBar.vue";
import FormStatus from "./formsteps/FormStatus.vue";
import axios from "axios";

export default {
	name: "FactoryForm",

	components: {
		AppToolbar,
		BasicStepMultiAnswer,
		BasicStepSubAnswer,
		BasicStepSingleAnswer,
		BasicStepWithChip,
		EnergyUsageTable,
		WaterUsageTable,
		MaterialUsageTable,
		WasteAmountTable,
		OurCompany,
		Economy,
		Environment,
		Social,
		FormStatus,
	},

	setup() {
		const store = useStore();
		const { user } = useAuth0();
		// Upate value here to debug each page
		let selected = ref("factory-ourcompany-intro");
		const multiAnswerTabs = [
			"factory-ourcompany-intro",
			"factory-ourcompany-stakeholders",
			"factory-ourcompany-suppliers",
			"factory-ourcompany-featurestory",

			"factory-economy-opportunities",
			"factory-economy-practices",
			"factory-economy-featurestory",
			"factory-economy-highlights",
			"factory-economy-activities",

			"factory-environment-suppliers",
			"factory-environment-carbon",
			"factory-environment-energyreduction",
			"factory-environment-wastewater",
			"factory-environment-materialreduction",

			"factory-social-diversity",
			"factory-social-employees",
			"factory-social-compliance",
			"factory-social-featurestory-diversity",
			"factory-social-featurestory-training",
			"factory-social-community",
			"factory-social-culturalheritage",
			"factory-social-featurestory-community",
			"factory-social-partner",
			"factory-social-featurestory-commitment",
			"factory-social-safetymeasures",
			"factory-social-safety",
			"factory-social-wellbeing",
			"factory-social-featurestory-commitment",
			"factory-social-featurestory-safety",
		];

		const singleAnswerTabs = [
			"factory-environment-wastetreatment",
			
		];

		const multiSubAnswersTabs = [
			"factory-environment-waterreduction",
			"factory-environment-strategy",
		];

		const multiSubAnswersWithChipTabs = ["factory-ourcompany-commitment"];

		function getStep(val) {
			if (val == null) {
				console.error("selected val is null");
			} else {
				var question = stepQuestions.filter((x) => x.value === val);
				if (question.length >= 1) {
					return question[0];
				} else {
					console.error("Failed to find the step", val);
					return null;
				}
			}
		}

		function showStatus() {
			selected.value = "show-status-tab";
		}

		function getQuestion(val) {
			return getStep(val).question;
		}

		function getGuildline(val) {
			return getStep(val).guildline;
		}

		function getPicLabel(val) {
			return getStep(val).picturelabel;
		}
		function getPicRatio(val) {
			return getStep(val).pictureratio;
		}

		function getSampleAnswers(val) {
			return getStep(val).sampleanswers;
		}

		function getLabel(val) {
			return getStep(val).label;
		}

		function getSamplesubanswers(val) {
			return getStep(val).samplesubanswers;
		}

		function getCharactersCount(val) {
			var limit = getStep(val).charactercnt;
			if (limit) {
				return parseInt(limit);
			}
			return 500;
		}

		async function userHasData() {
			const usercode = JSON.stringify(user.value, null, 2);
			const userid = JSON.parse(usercode)["sub"];
			let response = await axios.get(
				// "https://formanswer.azurewebsites.net/api/getFormByUser?id=" + userid,
				"https://testdynimosazure.azurewebsites.net/api/getFormByUser?id=" + userid,
				{
					headers: {},
				}
			);
			if (response) {
				return true;
			}
			return null;
		}

		onMounted(async () => {
			const returnUser = await userHasData();
			const usercode = JSON.stringify(user.value, null, 2);
			const userid = JSON.parse(usercode)["sub"];
			if (returnUser) {
				store.dispatch("loadItems", {
					template: "factory",
					userid: userid,
				});
			} else {
				store.commit("updateSingleState", {
					label: "template",
					value: "factory",
				});
			}
		});

		return {
			splitterModel: ref(20),
			steptree: stepNode,
			selected,
			introAnswers: ref(null),
			getQuestion,
			getGuildline,
			getPicLabel,
			getPicRatio,
			getSampleAnswers,
			getSamplesubanswers,
			getLabel,
			getCharactersCount,
			multiAnswerTabs,
			singleAnswerTabs,
			multiSubAnswersTabs,
			multiSubAnswersWithChipTabs,
			showStatus,
		};
	},
};
</script>
